export default __webpack_public_path__ + "static/media/d6c3d1fa9e52a071338517b6557e5791.svg";